module.exports = __webpack_public_path__ + "static/media/bg_cetesc.7a9a0adf.png";